/**
 * Estimate maximum keyboard height (conservative estimation to ensure safe distance)
 * @returns {number} Estimated keyboard height in pixels
 */
export function estimateMaxKeyboardHeight() {
  // Device detection (simplified iOS check)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Get screen dimensions and orientation
  const screenHeight = window.innerHeight;
  const isLandscape = window.matchMedia('(orientation: landscape)').matches;

  // Base height ratio (conservative maximum estimation)
  let baseHeightRatio;
  if (isIOS) {
    // iOS keyboard max heights (50% portrait, 30% landscape)
    baseHeightRatio = isLandscape ? 0.3 : 0.5;
  } else {
    // Android keyboard max heights (60% portrait, 40% landscape)
    baseHeightRatio = isLandscape ? 0.4 : 0.6;
  }

  // Calculate base height + safe area (extra handling for iOS)
  const safeAreaInsetBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat')) || 0;

  // Final height: take max value from ratio, empirical max, and safe area
  const estimatedHeight = Math.max(
    screenHeight * baseHeightRatio, // Ratio calculation
    isIOS ? 336 : 420, // Empirical max heights (iPhone 15 Pro Max/Pixel 7)
    safeAreaInsetBottom, // Safe area inset
  );

  // Ensure minimum value (prevent extreme cases)
  return Math.min(estimatedHeight, screenHeight * 0.8);
}
